$(document).ready(function()
{
    // Header
    let header = $(".fixedheader");

    if (window.innerWidth > 980)
    { // window > 980

        $(window).scroll(function()
        {
            let stt = $(window).scrollTop(); // scroll to top
            let ww = $(window).innerWidth(); // window width
            let hh = header.height(); // header height
            if (ww >= 980)
            {
                if (stt >= 1)
                {
                    header.addClass('shrunk');
                } else {
                    header.removeClass('shrunk');
                }
            }
        });

        $(window).resize(function()
        {
            let stt = $(window).scrollTop(); // scroll to top
            let ww = $(window).innerWidth(); // window width
            let hh = header.height(); // header height
            if (ww <= 980)
            {
                header.addClass('shrunk');
            }
            if ((ww > 980) && (stt == 0))
            {
                header.removeClass('shrunk');
            }
        });

    } else
    { // window <= 980
        header.addClass('shrunk');

        $(window).scroll(function()
        {
            let stt = $(window).scrollTop(); // scroll to top
            let ww = $(window).innerWidth(); // window width
            let hh = header.height(); // header height
            if (ww >= 980)
            {
                if (stt >= 1)
                {
                    header.addClass('shrunk');
                } else {
                    header.removeClass('shrunk');
                }
            }
        });

        $(window).resize(function()
        {
            let stt = $(window).scrollTop(); // scroll to top
            let ww = $(window).innerWidth(); // window width
            let hh = header.height(); // header height
            if (ww <= 980)
            {
                header.addClass('shrunk');
            }
            if ((ww > 980) && (stt == 0))
            {
                header.removeClass('shrunk');
            }
        });
    }

    // Offset
    $(window).resize(function() {
        setTimeout(function() {
            $(".page-wrap").css("margin-top", header.height());
        }, 500);
    }).resize();

    // Mega menu
    $('#main-nav .dropdown').first().find('.megamenu li:not(:first) li a').each(function()
    {
        if ($(this).text() == '###personalised-img-ph###')
        {
            $(this).html('<img src="https://cdn.shopify.com/s/files/1/2414/2679/files/mega-menu-personalise.jpg?10596190116655478414">');
        }
        if ($(this).text() == '###corporate-branded-img-ph###')
        {
            $(this).html('<img src="https://cdn.shopify.com/s/files/1/2414/2679/files/mega-menu-corporate-branded.jpg?17056377979898450518">');
        }
        if ($(this).text() == '###bespoke-custom-img-ph###')
        {
            $(this).html('<img src="https://cdn.shopify.com/s/files/1/2414/2679/files/mega-menu-bespoke-custom.jpg?4070643352046935778">');
        }
    });

    // Mobile menu
    $('nav.shifter-navigation .search').remove();
    $('nav.shifter-navigation').append('<div class="mobile-menu-search"><a href="/search"><i class="fa fa-search" aria-hidden="true"></i> Search</a></div>');
    $('nav.shifter-navigation').append('<div class="mobile-menu-contact"><p> <span class="title">Get in touch</span><br>We are open Monday to Friday, 8:30-5pm and weekends by appointment.</p><p><span class="title">CONTACT US</span><br>PHONE: <a href="tel:00441780762550">+44 (0)1780 762 550</a></p></div>');

    // Product details
    $('#embossing-option').on('change', function()
    {
        let embossOpt = $(this).val();
        if (embossOpt == 'Select an option')
        {
            // Hide Emboss Message inputs and clear values
            $('[data-pe-message]').hide().val('');
            $('#embossing-message, #embossing-message-line-2').val('');
            $('.embossing-countdown, embossing-countdown-line-2').hide().val('');
            $('.embossing-wrapper').hide();
            $('#embossing-position, #embossing-colour').val('');
        }
        if (embossOpt == '4 Initials')
        {
            $('[data-pe-message]').hide().val('');
            $('#embossing-message, #embossing-message-line-2').val('');
            $('.embossing-countdown-line-2').hide().val('');
            $('.embossing-wrapper').hide();
            $('.embossing-wrapper, [data-pe-message=4], .embossing-countdown').show();
            $('.embossing-countdown').text('4');
            $('[data-pe-message=4]').on('keyup', function()
            {
                let count = this.value.length;
                let remaining = 4 - count;
                let msg = $(this).val();
                $('.embossing-countdown').text(remaining);
                $('#embossing-message').val(msg);
            });
            $('#embossing-position, #embossing-colour').val('');
        }
        if (embossOpt == 'Up to 20 characters' || embossOpt == 'Single line, up to 20 characters')
        {
            $('[data-pe-message]').hide().val('');
            $('#embossing-message, #embossing-message-line-2').val('');
            $('.embossing-countdown-line-2').hide().val('');
            $('.embossing-wrapper').hide();
            $('.embossing-wrapper, [data-pe-message=20], .embossing-countdown').show();
            $('.embossing-countdown').text('20');
            $('[data-pe-message=20]').on('keyup', function()
            {
                let count = this.value.length;
                let remaining = 20 - count;
                let msg = $(this).val();
                $('.embossing-countdown').text(remaining);
                $('#embossing-message').val(msg);
            });
            $('#embossing-position, #embossing-colour').val('');
        }
        if (embossOpt == 'Up to 30 characters' || embossOpt == 'Single line, up to 30 characters')
        {
            $('[data-pe-message]').hide().val('');
            $('#embossing-message, #embossing-message-line-2').val('');
            $('.embossing-countdown-line-2').hide().val('');
            $('.embossing-wrapper').hide();
            $('.embossing-wrapper, [data-pe-message=30], .embossing-countdown').show();
            $('.embossing-countdown').text('30');
            $('[data-pe-message=30]').on('keyup', function()
            {
                let count = this.value.length;
                let remaining = 30 - count;
                let msg = $(this).val();
                $('.embossing-countdown').text(remaining);
                $('#embossing-message').val(msg);
            });
            $('#embossing-position, #embossing-colour').val('');
        }

        if (embossOpt == 'Double line, up to 60 characters')
        {
            $('[data-pe-message]').hide().val('');
            $('#embossing-message, #embossing-message-line-2').val('');
            $('.embossing-wrapper').hide();
            $('.embossing-wrapper, [data-pe-message=30], [data-pe-message=30-2], .embossing-countdown, .embossing-countdown-line-2').show();
            $('.embossing-countdown').text('30');
            $('.embossing-countdown-line-2').text('30');
            $('[data-pe-message=30]').on('keyup', function()
            {
                let count = this.value.length;
                let remaining = 30 - count;
                let msg = $(this).val();
                $('.embossing-countdown').text(remaining);
                $('#embossing-message').val(msg);
            });
            $('[data-pe-message=30-2]').on('keyup', function()
            {
                let count2 = this.value.length;
                let remaining2 = 30 - count2;
                let msg2 = $(this).val();
                $('.embossing-countdown-line-2').text(remaining2);
                $('#embossing-message-line-2').val(msg2);
            });
            $('#embossing-position, #embossing-colour').val('');
        }
    });

    // Product details
        // Embossing
        if ( $('body').is('[class*="product"]') )
        {
            // Reset Embossing and Gift Box add-on
            $('select[id^=product-select-]').on('change', function()
            {
                $('#add-on-gift-box').prop('checked', false);
                $('label[for="add-on-gift-box"]').html('<i class="fa fa-gift"></i> Add Gift Box +£6.95');
            });
            // Hide variants
            let vs = $('.product-options-left label:contains("Size")').filter(function()
            { // variant single size
                if ( $(this).next().text().indexOf("Single size") >= 0 )
                // if($(this).next().text() === 'Single size')
                {
                    $(this).parent().hide();
                }
            });

            let ve = $('.product-options-left label:contains("Embossing")').filter(function()
            { // variant embossing
                if($(this).text() === 'Embossing')
                {
                    $(this).parent().hide();
                }
                return $(this).text() === "Embossing"; // Required to display value in embossing options
            });
            // Set embossing options based on variant id
            let veVal = ve.next().val(); // Get embossing value on load
            if (veVal && veVal != 'Select an option')
            {
                $('select#embossing-option').val(veVal).trigger('change');
                $('#AddToCart').prop('disabled', true);
            }
            // Update variant
            $('select#embossing-option').on('change', function()
            {
                ve.next().val($(this).val()).trigger('change');
                $(this.options).filter(function()
                { // Update default option
                    return $(this).text() === "Select an option";
                }).text('Remove Embossing');
                // console.log($(this.options).filter(':selected').text());
                if ($(this.options).filter(':selected').text() === 'Remove Embossing') {
                    // console.log('fired!');
                    $(this.options).filter(function()
                    { // Update default option
                        return $(this).text() === "Remove Embossing";
                    }).text('Select an option');
                }
                // Disable ADD TO CART
                let et = $(this).val(); // embossing type
                if (et === "Select an option")
                {
                    $('#AddToCart').prop('disabled', false);
                } else {
                    $('#AddToCart').prop('disabled', true);
                }
            });
            // Product validation
            $('[name^=embossing-message-]').on('focus', function()
            {
                $('#embossing-position, #embossing-colour').val('');
                $('#AddToCart').prop('disabled', true);
            });
            $('[name^=embossing-message-]').on('blur', function()
            {
                $(this).trigger('keyup');
            });
            $('#embossing-position').on('focus', function()
            {
                $('#embossing-colour').val('');
                $('#AddToCart').prop('disabled', true);
            });
            $('#embossing-colour').on('change', function()
            {
                if( ($(this).val() != '') && ($('#embossing-message').val() != '') && ($('#embossing-position').val() != ''))
                {
                    $('#AddToCart').prop('disabled', false);
                } else {
                    $('#AddToCart').prop('disabled', true);
                }
            });
        }
    // Product quantity
        $("button.qty-update").on('click', function(e)
        {
            if ( $('body').is('[class*="product"]') )
            {
                let qty = $('.product-add input.quantity').val();

                if($(this).attr('name') == 'qty-add')
                {
                    let newQty = parseFloat(qty) + 1;
                    $('.product-add input.quantity').val(newQty);
                }

                if($(this).attr('name') == 'qty-minus')
                {
                    if(qty > 1)
                    {
                        let newQty = parseFloat(qty) - 1;
                        $('.product-add input.quantity').val(newQty);
                    } else {
                        let newQty = 1;
                        $('.product-add input.quantity').val(newQty);
                    }
                }
            }
        });
    // Product: Add on Gift Box
        if ( $('body').is('[class*="product"]') )
        {
            $('label[for=add-on-gift-box]').on('click', function(e)
            {
                $(this).html('<i class="fa fa-gift"></i> Remove Gift Box');
                if($('input#add-on-gift-box').is(':checked'))
                {
                    $(this).html('<i class="fa fa-gift"></i> Add Gift Box +£6.95');
                    // Update product price - screen only
                    let price = $('#product-price span.product-price').text().replace('£', '');
                    price = parseFloat(price) - 6.95;
                    // price = price.toString();
                    $('#product-price span.product-price').text('£'+price.toFixed(2));
                } else {
                    $(this).html('<i class="fa fa-gift"></i> Remove Gift Box');
                    // Update product price - screen only
                    let price = $('#product-price span.product-price').text().replace('£', '');
                    price = parseFloat(price) + 6.95;
                    // price = price.toString();
                    $('#product-price span.product-price').text('£'+price.toFixed(2));
                }
            });
        }
    // Cart: Gift Boxes and Pen Pockets + Gift Wrapping + Lay Flat Binding (we need to do this - what is the variant id?? 9679072231671)
        if ( $('body').is('[class*="cart"]') )
        {
            $('body.cart a[href$="variant=7194892075036"]:has(img)').each(function()
            {
                $(this).replaceWith($(this).children());
            });
            // Gift Box
            $('body.cart a[onclick^="remove_item(7194892075036)"]').hide();
            $('body.cart input#updates_7194892075036').prop('disabled', true);
            // Pen Pocket
            $('body.cart a[onclick^="remove_item(15319653023793)"]').hide();
            $('body.cart input#updates_15319653023793').prop('disabled', true);
            // Lay Flat
            $('body.cart a[onclick^="remove_item(49731699343607)"]').hide();
            $('body.cart input#updates_49731699343607').prop('disabled', true);
             // Edge Gliding
            $('body.cart a[onclick^="remove_item(43230637490423)"]').hide();
            $('body.cart input#updates_43230637490423').prop('disabled', true);
            // Gift Wrapping
            $('body.cart a[onclick^="remove_item(43639985799415)"]').hide();
            $('body.cart input#updates_43639985799415').prop('disabled', true);
            // Remove whitespace from .cart-title > line_items
            $('body.cart .cart-title').each(function()
            {
                let str = $(this).html().replace(/\s\s+/g, ' ');
                $(this).html(str);
            });
            // Update .cart-title line_item - this bit does work! 6.62025
            let strAddonGiftBox = $('body.cart').html().replace(/ Addon: Gift Box /g,'<br><strong class="cart-gift-box-included">Include Gift Box</strong> (added to cart)');
            $('body.cart').html(strAddonGiftBox);

            // Update Embossing line item if not required
            let strEmbossing = $('body.cart').html().replace(/ Embossing: Select an option /g,'Embossing: N/A');
            $('body.cart').html(strEmbossing);

            // Update Pen Loop & Pocket line item if not required
            let strPenLoopPocket = $('body.cart').html().replace(/ Addon2: Pen Loop/g,'Addon: Pen Loop');
            $('body.cart').html(strPenLoopPocket);

            // Update Lay Flat Binding line item if not required
            let strLayFlatBinding = $('body.cart').html().replace(/ Addon5: Lay Flat/g,'Addon: Lay Flat');
            $('body.cart').html(strLayFlatBinding);

          // Update Edge Gliding line item if not required
            let strEdgeGlidingPocket = $('body.cart').html().replace(/ Addon3: Edge Gliding/g,'Addon: Edge Gliding');
            $('body.cart').html(strEdgeGlidingPocket);

          // Update Gift Wrapping line item if not required
            let strGiftWrappingPocket = $('body.cart').html().replace(/ Addon4: Gift Wrapping/g,'Addon: Gift Wrapping');
            $('body.cart').html(strGiftWrappingPocket);

          // Update Message on the Gift wrapping line item if not required
            let strGiftwrappingMessage = $('body.cart').html().replace(/Message on the Gift wrapping:/g,'Gift wrapping Message: <br>');
            $('body.cart').html(strGiftwrappingMessage);
          
        }
    // Product: Add on Pen Pocket + Edge Gliding + Gift Wrapping + Lay Flat Binding
  // I don't think that these work! 6.6.2025 - they do 7.6.2025!
  
        if ( $('body').is('[class*="product"]') )
        {
            $('label[for=add-on-pen-pocket]').on('click', function(e)
            {
                $(this).html('<i class="fa fa-pencil"></i> Remove Pen Loop & Pocket');
                if($('input#add-on-pen-pocket').is(':checked'))
                {
                    $(this).html('<i class="fa fa-pencil"></i> Add Pen Loop & Pocket +£5.00');
                    // Update product price - screen only
                    let price = $('#product-price span.product-price').text().replace('£', '');
                    price = parseFloat(price) - 5.00;
                    // price = price.toString();
                    $('#product-price span.product-price').text('£'+price.toFixed(2));
                } else {
                    $(this).html('<i class="fa fa-pencil"></i> Remove Pen Loop & Pocket');
                    // Update product price - screen only
                    let price = $('#product-price span.product-price').text().replace('£', '');
                    price = parseFloat(price) + 5.00;
                    // price = price.toString();
                    $('#product-price span.product-price').text('£'+price.toFixed(2));
                }
            });

               $('label[for=add-on-lay-flat]').on('click', function(e)
            {
                $(this).html('<i class="fa fa-book-open"></i> Remove Lay Flat Binding');
                if($('input#add-on-lay-flat').is(':checked'))
                {
                    $(this).html('<i class="fa fa-book-open"></i> Add Lay Flat Binding +£5.00');
                    // Update product price - screen only
                    let price = $('#product-price span.product-price').text().replace('£', '');
                    price = parseFloat(price) - 5.00;
                    // price = price.toString();
                    $('#product-price span.product-price').text('£'+price.toFixed(2));
                } else {
                    $(this).html('<i class="fa fa-book-open"></i> Remove Lay Flat Binding');
                    // Update product price - screen only
                    let price = $('#product-price span.product-price').text().replace('£', '');
                    price = parseFloat(price) + 5.00;
                    // price = price.toString();
                    $('#product-price span.product-price').text('£'+price.toFixed(2));
                }
            });

          $('label[for=add-on-edge-gliding]').on('click', function(e)
            {
                $(this).html('<i class="fa fa-book"></i> Remove Edge Gilding');
                if($('input#add-on-edge-gliding').is(':checked'))
                {
                    $(this).html('<i class="fa fa-book"></i> Add Edge Gilding +£10.00');
                    // Update product price - screen only
                    let price = $('#product-price span.product-price').text().replace('£', '');
                    price = parseFloat(price) - 10.00;
                    // price = price.toString();
                    $('#product-price span.product-price').text('£'+price.toFixed(2));
                } else {
                    $(this).html('<i class="fa fa-book"></i> Remove Edge Gilding');
                    // Update product price - screen only
                    let price = $('#product-price span.product-price').text().replace('£', '');
                    price = parseFloat(price) + 10.00;
                    // price = price.toString();
                    $('#product-price span.product-price').text('£'+price.toFixed(2));
                }
            });
            $('label[for=add-on-gift_wrapping]').on('click', function(e){
                $('#message-wrapping').show();
                $(this).html('<i class="fa fa-gift"></i> Remove Gift Wrapping');
                if($('input#add-on-gift_wrapping').is(':checked'))
                {
                    $('#message-wrapping').hide();
                    $(this).html('<i class="fa fa-gift"></i> Add Gift Wrapping +£6.95');
                    // Update product price - screen only
                    let price = $('#product-price span.product-price').text().replace('£', '');
                    price = parseFloat(price) - 6.95;
                    // price = price.toString();
                    $('#product-price span.product-price').text('£'+price.toFixed(2));

                } else {
                    $('#message-wrapping').show();
                    $(this).html('<i class="fa fa-gift"></i> Remove Gift Wrapping');
                    // Update product price - screen only
                    let price = $('#product-price span.product-price').text().replace('£', '');
                    price = parseFloat(price) + 6.95;
                    // price = price.toString();
                    $('#product-price span.product-price').text('£'+price.toFixed(2));
                }
            });
        }
});
